module.exports = "<textarea id=\"froala\" [(froalaModel)]=\"text\" [froalaEditor]=\"options\"></textarea>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/rich-text-editor/rich-text-editor.component.html
// module id = ../../../../../src/app/shared/components/rich-text-editor/rich-text-editor.component.html
// module chunks = 12